export const data = {
	heading: 'Наша команда работает с 2012 года',
	content:
		'В 2012 году мы зарегистрировали первую компанию из нашей группы ООО МКК «Магазин кредитов». Тогда и стали выдавать займы предпринимателям  и частным лицам. С этого времени мы начали усиливать свою экспертизу:',
	list: [
		'в залоговом кредитовании и кредитных технологиях;',
		'детальной экономической оценки недвижимости;',
		'юридической проверке заёмщика и объекта залога;',
	],
}
